import React from 'react'
import { change, show, store, update, test, success as changeSuccess } from '../../../store/actions/pixel.action'
import { CircularProgress, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import { FaSave, FaLink } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'

export default function LinksEdit(props) {
    const dispatch = useDispatch()
    const { pixel, success, error } = useSelector(state => state.pixelReducer)
    const id = (props.uid) ? props.uid : null

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        if (id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        } else {
            setLoading(false)
        }
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _save = () => {
        if(id) {
            dispatch(update(id, pixel))
        } else {
            dispatch(store({
                'title' : pixel.title,
                'pixel' : pixel.pixel,
                'pixel_access_token' : pixel.pixel_access_token
            }))
        }
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Pixel' : 'Novo Pixel'}
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save() }
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Titulo</label>
                            <TextField
                                error={(error.title) && true}
                                value={pixel.title || ''}
                                placeholder="Ex: Pixel Instagram"
                                onChange={text => {
                                    dispatch(change({ title: text.target.value }))
                                    if (error.title && delete error.title);
                                }}
                            />

                            {(error.title) &&
                                <strong className="text-danger">{error.title[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Pixel</label>
                            <TextField
                                error={(error.pixel) && true}
                                value={pixel.pixel || ''}
                                placeholder="ID Pixel Facebook"
                                onChange={text => {
                                    dispatch(change({ pixel: text.target.value }))
                                    if (error.pixel && delete error.pixel);
                                }}
                            />

                            {(error.pixel) &&
                                <strong className="text-danger">{error.pixel[0]}</strong>
                            }
                        </div>

                        <div className="mb-4">
                            <label className="label-custom bs-color-b">API de Conversões</label>
                            <TextField
                                multiline
                                minRows="2"
                                error={(error.pixel_access_token) && true}
                                value={pixel.pixel_access_token || ''}
                                placeholder="Access Token API de Conversões"
                                onChange={text => {
                                    dispatch(change({ pixel_access_token: text.target.value }))
                                    if (error.pixel_access_token && delete error.pixel_access_token);
                                }}
                            />

                            {(error.pixel_access_token) &&
                                <strong className="text-danger">{error.pixel_access_token[0]}</strong>
                            }
                        </div>

                        <div className="mb-3">
                            <FormControl component="fieldset">
                                <FormLabel className="bs-color" component="legend">Envio de Dados</FormLabel>
                                <RadioGroup
                                    value={pixel.share_data || 'all'} 
                                    onChange={ e => dispatch(change({share_data: e.target.value}))}
                                    className="fw-normal bs-color-b"
                                >
                                    <FormControlLabel className="ads-all" value="all" control={<Radio color="primary" />} label="Orgânico e ADS" />
                                    <FormControlLabel value="only" control={<Radio color="primary" />} label="ADS" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        <div className="mb-3">
                            <Button
                                disabled={(!pixel.pixel || !pixel.pixel_access_token)}
                                variant="contained"
                                size="small"
                                color="primary"
                                startIcon={<FaLink />}
                                onClick={() => dispatch(test(pixel.pixel, pixel.pixel_access_token))}
                            >
                                Testar API
                            </Button>
                        </div>

                        <div className="mb-3">
                            <div className="alert alert-success mt-3" role="alert">
                                <strong>Orgânico e ADS:</strong> Envia para o pixel todos os eventos seja tráfego organico ou patrocinado.<strong>Recomendado pela Meta</strong>
                            </div>
                            <div className="alert alert-warning mt-3" role="alert">
                                <strong>ADS:</strong> Envia para o pixel todos os eventos do tráfego patrocinado. <strong>Dados do tráfego organico não são enviados</strong>
                            </div>
                        </div> 
                    </div>
                </>
            }
        </div>
    )
}